import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const PmStore = create(
	persist(
		(set) => ({
			isAuthenticated: false,
			selectedOrganization: null,
			token: null,
			knownOrganizations: [],
			claims: {},
			billingSettings: null,
			applicationSettings: null,
			platformSettings: null,

			// setToken: (tok) => set((state) => ({ token: tok, isAuthenticated: true })),
			setToken: (newToken) =>
				set((state) => ({
					token: newToken,
					isAuthenticated: true,
					claims: (decodeJwt(newToken)).claims,
				})),

			resetToken: () =>
				set((state) => ({
					token: null,
					isAuthenticated: false,
					claims: {},
					knownOrganizations: [],
					selectedOrganization: null,
				})),



			reset: () =>
				set((state) => ({
					token: null,
					isAuthenticated: false,
					claims: {},
					knownOrganizations: [],
					selectedOrganization: null,
					billingSettings: null,
					applicationSettings: null,
					platformSettings: null,
				})),

			setSelectedOrg: (org) => 
				set((state) => ({selectedOrganization: org})),

			setKnownOrganizations: (orgs) =>
				set((state) => ({knownOrganizations: orgs})),

			setBillingSettings: (settings) =>
				set((state) => ({billingSettings: settings,})),



		}),
		{
			name: "pm-store", // name of the item in the storage (must be unique)
			storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used

		}
	)
);

function decodeJwt(token) {
	const [h64, c64, signature] = token.split('.');
	const jwt = {
		header: (h64) ? JSON.parse(atob(h64)) : null,
		claims: (c64) ? JSON.parse(atob(c64)) : null,
		signature
	}
	return jwt;
}